// extracted by mini-css-extract-plugin
export default {"form":"SettingsForm_form__pS0qC","action":"SettingsForm_action__QdYwr"};